import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt, faClock, faClipboardCheck, faShieldAlt } from "@fortawesome/free-solid-svg-icons";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setStatusMessage('');

        const formDataToSend = new FormData();
        formDataToSend.append('name', formData.name);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('subject', formData.subject);
        formDataToSend.append('message', formData.message);

        try {
            const response = await fetch('/forms/contact.php', {
                method: 'POST',
                body: formDataToSend
            });

            // Check if response is ok
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // Get the response text first
            const responseText = await response.text();

            // Check if response is empty
            if (!responseText || responseText.trim() === '') {
                throw new Error('Server returned empty response');
            }

            // Try to parse JSON
            let result;
            try {
                result = JSON.parse(responseText);
            } catch (jsonError) {
                console.error('JSON Parse Error:', jsonError);
                console.error('Response that failed to parse:', responseText);
                throw new Error('Server returned invalid JSON response: ' + responseText.substring(0, 100));
            }

            if (result.success) {
                setMessageType('success');
                setStatusMessage(result.message || 'Thank you. Your consultation request has been received, and our team will respond within 1 business day.');
                setFormData({ name: '', email: '', subject: '', message: '' });
            } else {
                setMessageType('error');
                setStatusMessage(result.message);
            }
        } catch (error) {
            setMessageType('error');
            setStatusMessage('We could not send your request right now. Please email chandrakant.namera@anmatics.com or call +91 88668 99005.');
            console.error('Contact form error:', error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <section id="contact" className="contact-section contact-lean py-5">
            <div className="container" data-aos="fade-up">
                <div className="row g-4">
                    <div className="col-lg-4">
                        <div className="contact-info-panel h-100">
                            <span className="section-kicker">Contact</span>
                            <h2 className="section-title fw-bold text-start">Book a technical consultation.</h2>
                            <p className="section-subtitle text-muted text-start">
                                Share your SaaS, automation, enterprise app, or modernization requirement. We will respond with a practical next step.
                            </p>
                            <div className="contact-confidence-list">
                                <div>
                                    <span className="contact-icon-box">
                                        <FontAwesomeIcon icon={faClock} />
                                    </span>
                                    <div>
                                        <strong>Response within 1 business day</strong>
                                        <p className="mb-0 text-muted">We review every request before replying.</p>
                                    </div>
                                </div>
                                <div>
                                    <span className="contact-icon-box">
                                        <FontAwesomeIcon icon={faClipboardCheck} />
                                    </span>
                                    <div>
                                        <strong>Practical technical discussion</strong>
                                        <p className="mb-0 text-muted">Scope, constraints, stack, and next steps.</p>
                                    </div>
                                </div>
                                <div>
                                    <span className="contact-icon-box">
                                        <FontAwesomeIcon icon={faShieldAlt} />
                                    </span>
                                    <div>
                                        <strong>Private by default</strong>
                                        <p className="mb-0 text-muted">Your project details stay confidential.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="contact-detail-list">
                                <div>
                                    <span className="contact-icon-box">
                                        <FontAwesomeIcon icon={faEnvelope} />
                                    </span>
                                    <a href="mailto:chandrakant.namera@anmatics.com" className="text-decoration-none text-dark fw-semibold">
                                        chandrakant.namera@anmatics.com
                                    </a>
                                </div>
                                <div>
                                    <span className="contact-icon-box">
                                        <FontAwesomeIcon icon={faPhone} />
                                    </span>
                                    <a href="tel:+918866899005" className="text-decoration-none text-dark fw-semibold">
                                        +91 88668 99005
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-8">
                        <div className="contact-card shadow-sm p-4 bg-white rounded-4">
                            <div className="contact-office-strip">
                                <div className="contact-office-item">
                                    <span className="contact-icon-box">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                                    </span>
                                    <div>
                                        <div className="fw-semibold mb-1">
                                            Head Office - Rajkot
                                        </div>
                                        <p className="mb-0 text-muted">
                                            203, Ikon Complex, Opp. Sun City Apartment,<br />
                                            Sadhu Vaswani Road, Rajkot - 360005, India
                                        </p>
                                    </div>
                                </div>
                                <div className="contact-office-item">
                                    <span className="contact-icon-box">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                                    </span>
                                    <div>
                                        <div className="fw-semibold mb-1">
                                            Branch Office - Morbi
                                        </div>
                                        <p className="mb-0 text-muted">
                                            207, Second Floor, City Mall, Nr. Bhaktinagar Bypass,<br />
                                            Sanala Road, Morbi, Gujarat - 363641, India
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <h5 className="fw-bold mb-3 text-gradient">Tell us what you want to build</h5>
                            <p className="contact-form-note text-muted">
                                A short brief is enough. Include the product type, current stage, main challenge, and preferred timeline if available.
                            </p>
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            placeholder="Your name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email"
                                            placeholder="Work email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-12">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="subject"
                                            placeholder="Project type, for example SaaS platform or legacy modernization"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-12">
                                        <textarea
                                            className="form-control"
                                            name="message"
                                            rows="4"
                                            placeholder="Tell us what you want to build, improve, automate, or scale."
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="contact-submit-row mt-4">
                                    <p className="contact-privacy-note mb-0">
                                        No sales spam. We use your details only to respond to this request.
                                    </p>
                                    <button type="submit" className="btn btn-gradient px-4 py-2 rounded-pill" disabled={isLoading}>
                                        {isLoading ? 'Sending...' : 'Request Consultation'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Status Message */}
                {statusMessage && (
                    <div className={`alert mt-4 text-center ${messageType === 'success' ? 'alert-success' : 'alert-danger'}`}>
                        {statusMessage}
                    </div>
                )}
            </div>
        </section>
    );
};

export default Contact;
